import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b4173e8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-event-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Edit Event", -1))
const _hoisted_4 = { class: "calendar-name" }
const _hoisted_5 = {
  key: 0,
  class: "loading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading event data...", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "error-message"
}
const _hoisted_9 = { class: "form-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Basic Information", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Event Title *", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Event Type *", -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-b4173e8c>Select Event Type</option><option value=\"closed\" data-v-b4173e8c>Closed</option><option value=\"early\" data-v-b4173e8c>Early Dismissal</option><option value=\"shortened\" data-v-b4173e8c>Shortened Day</option><option value=\"late_start\" data-v-b4173e8c>Late Start</option>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_23 = { class: "form-section" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Date and Time", -1))
const _hoisted_25 = { class: "form-row" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date *", -1))
const _hoisted_28 = ["min", "max"]
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date", -1))
const _hoisted_31 = ["min", "max"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave blank for single-day events", -1))
const _hoisted_33 = { class: "form-row" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startTime" }, "Start Time", -1))
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endTime" }, "End Time", -1))
const _hoisted_38 = { class: "form-group checkbox-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affectsAttendance" }, "This event affects attendance", -1))
const _hoisted_40 = { class: "form-section" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Grade Ranges", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, "Select which grade levels this event applies to", -1))
const _hoisted_43 = { class: "grade-ranges" }
const _hoisted_44 = { class: "form-group checkbox-group" }
const _hoisted_45 = ["checked"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allGrades" }, "All Grades", -1))
const _hoisted_47 = { class: "form-group checkbox-group" }
const _hoisted_48 = ["checked", "disabled"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "elementary" }, "Elementary (PreK-5)", -1))
const _hoisted_50 = { class: "form-group checkbox-group" }
const _hoisted_51 = ["checked", "disabled"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "middle" }, "Middle School (6-8)", -1))
const _hoisted_53 = { class: "form-group checkbox-group" }
const _hoisted_54 = ["checked", "disabled"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "high" }, "High School (9-12)", -1))
const _hoisted_56 = { class: "form-section" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Recurring Options", -1))
const _hoisted_58 = { class: "form-group checkbox-group" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "isRecurring" }, "This is a recurring event", -1))
const _hoisted_60 = {
  key: 0,
  class: "recurring-options"
}
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "recurrencePattern" }, "Recurrence Pattern", -1))
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<option value=\"daily\" data-v-b4173e8c>Daily</option><option value=\"weekly\" data-v-b4173e8c>Weekly</option><option value=\"biweekly\" data-v-b4173e8c>Bi-weekly</option><option value=\"monthly\" data-v-b4173e8c>Monthly</option><option value=\"yearly\" data-v-b4173e8c>Yearly</option>", 5)
const _hoisted_68 = [
  _hoisted_63
]
const _hoisted_69 = {
  key: 0,
  class: "form-section"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Bell Schedule", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, " Define the periods for this bell schedule. Click \"Add Period\" to add more periods. ", -1))
const _hoisted_72 = { class: "period-header" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "form-row" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = ["for"]
const _hoisted_77 = ["id", "onUpdate:modelValue"]
const _hoisted_78 = { class: "form-group" }
const _hoisted_79 = ["for"]
const _hoisted_80 = ["id", "onUpdate:modelValue"]
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<option value=\"class\" data-v-b4173e8c>Class</option><option value=\"break\" data-v-b4173e8c>Break</option><option value=\"lunch\" data-v-b4173e8c>Lunch</option><option value=\"assembly\" data-v-b4173e8c>Assembly</option><option value=\"other\" data-v-b4173e8c>Other</option>", 5)
const _hoisted_86 = [
  _hoisted_81
]
const _hoisted_87 = { class: "form-row" }
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = ["for"]
const _hoisted_90 = ["id", "onUpdate:modelValue"]
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = ["for"]
const _hoisted_93 = ["id", "onUpdate:modelValue"]
const _hoisted_94 = { class: "form-actions" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 1 }

import { ref, reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";

// Router and Route

export default /*#__PURE__*/_defineComponent({
  __name: 'EditEventView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const calendarId = route.params.calendarId as string;
const eventId = route.params.eventId as string;

// State
const calendarName = ref("");
const calendarStartDate = ref("");
const calendarEndDate = ref("");
const loading = ref(true);
const error = ref("");
const isSubmitting = ref(false);

// Form data
const formData = reactive({
  title: "",
  type: "",
  description: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  isRecurring: false,
  recurrencePattern: "daily",
  affectsAttendance: true,
  gradeRanges: ["all_grades"] as string[],
});

// Bell schedule data
const bellSchedule = reactive({
  periods: [
    {
      name: "",
      startTime: "",
      endTime: "",
      type: "class",
    },
  ],
});

// Functions
const fetchCalendarAndEvent = async () => {
  loading.value = true;
  try {
    // Fetch calendar info
    const calendarResponse = await axios.get(
      `${API_URL}/calendar/${calendarId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const calendar = calendarResponse.data;
    calendarName.value = calendar.name;
    calendarStartDate.value = calendar.startDate;
    calendarEndDate.value = calendar.endDate;

    // Fetch event info
    const eventResponse = await axios.get(
      `${API_URL}/calendar/${calendarId}/events/${eventId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const event = eventResponse.data;
    console.log("Fetched event data:", event);
    console.log("Event grade ranges:", event.gradeRanges);

    // Populate form data
    formData.title = event.title;
    formData.type = event.type;
    formData.description = event.description || "";
    formData.startDate = event.startDate;
    formData.endDate = event.endDate || "";
    formData.startTime = event.startTime || "";
    formData.endTime = event.endTime || "";
    formData.isRecurring = event.isRecurring || false;
    formData.recurrencePattern = event.recurrencePattern || "daily";
    formData.affectsAttendance =
      event.affectsAttendance !== undefined ? event.affectsAttendance : true;
    formData.gradeRanges = event.gradeRanges || ["all_grades"];
    console.log("Form data after population:", formData);
    console.log("Form grade ranges:", formData.gradeRanges);

    // Populate bell schedule if applicable
    if (
      event.type === "bell_schedule" &&
      event.bellSchedule &&
      event.bellSchedule.periods
    ) {
      bellSchedule.periods = [...event.bellSchedule.periods];
    }

    loading.value = false;
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch data");
    console.error("Error fetching data:", err);
    loading.value = false;
  }
};

const addPeriod = () => {
  bellSchedule.periods.push({
    name: "",
    startTime: "",
    endTime: "",
    type: "class",
  });
};

const removePeriod = (index: number) => {
  if (bellSchedule.periods.length > 1) {
    bellSchedule.periods.splice(index, 1);
  }
};

const submitForm = async () => {
  // Validate form
  if (!formData.title) {
    error.value = "Please enter an event title";
    return;
  }

  if (!formData.type) {
    error.value = "Please select an event type";
    return;
  }

  if (!formData.startDate) {
    error.value = "Please select a start date";
    return;
  }

  // Validate bell schedule if applicable
  if (formData.type === "bell_schedule") {
    if (bellSchedule.periods.length === 0) {
      error.value = "Please add at least one period to the bell schedule";
      return;
    }

    for (const period of bellSchedule.periods) {
      if (!period.name || !period.startTime || !period.endTime) {
        error.value = "Please complete all bell schedule period details";
        return;
      }
    }
  }

  isSubmitting.value = true;
  error.value = "";

  try {
    console.log("Submitting form data:", formData);
    console.log("Submitting grade ranges:", formData.gradeRanges);

    // Prepare data for submission
    const eventData = {
      ...formData,
      // Include bell schedule only if type is bell_schedule
      bellSchedule:
        formData.type === "bell_schedule" ? bellSchedule : undefined,
    };

    await axios.put(
      `${API_URL}/calendar/${calendarId}/events/${eventId}`,
      eventData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    // Navigate back to event view
    router.push(`/calendar/${calendarId}/events/${eventId}`);
  } catch (err: unknown) {
    isSubmitting.value = false;
    error.value = getErrorMessage(err, "Failed to update event");
    console.error("Error updating event:", err);
  }
};

const goBack = () => {
  router.push(`/calendar/${calendarId}/events/${eventId}`);
};

// Update the handlers in the script section
const handleAllGradesChange = (event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  console.log("All grades checkbox changed:", isChecked);

  if (isChecked) {
    formData.gradeRanges = ["all_grades"];
  } else {
    // When unchecking "All Grades", default to elementary
    formData.gradeRanges = ["elementary"];
  }

  console.log("Updated grade ranges:", formData.gradeRanges);
};

const handleGradeRangeChange = (grade: string, event: Event) => {
  const isChecked = (event.target as HTMLInputElement).checked;
  console.log(`${grade} checkbox changed:`, isChecked);

  if (isChecked) {
    // Add the grade if it's not already in the array
    if (!formData.gradeRanges.includes(grade)) {
      formData.gradeRanges.push(grade);
    }
  } else {
    // Remove the grade from the array
    formData.gradeRanges = formData.gradeRanges.filter((g) => g !== grade);

    // If no grades are selected, default to all grades
    if (formData.gradeRanges.length === 0) {
      formData.gradeRanges = ["all_grades"];
    }
  }

  console.log("Updated grade ranges:", formData.gradeRanges);
};

// Lifecycle hooks
onMounted(() => {
  fetchCalendarAndEvent();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: goBack
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "arrow-left" }),
        _createTextVNode(" Back to Event ")
      ])
    ]),
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, "Calendar: " + _toDisplayString(calendarName.value), 1),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _withModifiers(submitForm, ["prevent"]),
            class: "event-form"
          }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "title",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.title) = $event)),
                  required: "",
                  placeholder: "Enter event title"
                }, null, 512), [
                  [_vModelText, formData.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  id: "type",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.type) = $event)),
                  required: ""
                }, _hoisted_20, 512), [
                  [_vModelSelect, formData.type]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("textarea", {
                  id: "description",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.description) = $event)),
                  placeholder: "Enter event description",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, formData.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "startDate",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.startDate) = $event)),
                    required: "",
                    min: calendarStartDate.value,
                    max: calendarEndDate.value
                  }, null, 8, _hoisted_28), [
                    [_vModelText, formData.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "endDate",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.endDate) = $event)),
                    min: formData.startDate,
                    max: calendarEndDate.value
                  }, null, 8, _hoisted_31), [
                    [_vModelText, formData.endDate]
                  ]),
                  _hoisted_32
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    id: "startTime",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.startTime) = $event))
                  }, null, 512), [
                    [_vModelText, formData.startTime]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _withDirectives(_createElementVNode("input", {
                    type: "time",
                    id: "endTime",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.endTime) = $event))
                  }, null, 512), [
                    [_vModelText, formData.endTime]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "affectsAttendance",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.affectsAttendance) = $event))
                }, null, 512), [
                  [_vModelCheckbox, formData.affectsAttendance]
                ]),
                _hoisted_39
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "allGrades",
                    checked: formData.gradeRanges.includes('all_grades'),
                    onChange: handleAllGradesChange
                  }, null, 40, _hoisted_45),
                  _hoisted_46
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "elementary",
                    checked: formData.gradeRanges.includes('elementary'),
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (handleGradeRangeChange('elementary', $event))),
                    disabled: formData.gradeRanges.includes('all_grades')
                  }, null, 40, _hoisted_48),
                  _hoisted_49
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "middle",
                    checked: formData.gradeRanges.includes('middle'),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (handleGradeRangeChange('middle', $event))),
                    disabled: formData.gradeRanges.includes('all_grades')
                  }, null, 40, _hoisted_51),
                  _hoisted_52
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "high",
                    checked: formData.gradeRanges.includes('high'),
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (handleGradeRangeChange('high', $event))),
                    disabled: formData.gradeRanges.includes('all_grades')
                  }, null, 40, _hoisted_54),
                  _hoisted_55
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "isRecurring",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.isRecurring) = $event))
                }, null, 512), [
                  [_vModelCheckbox, formData.isRecurring]
                ]),
                _hoisted_59
              ]),
              (formData.isRecurring)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _withDirectives(_createElementVNode("select", {
                        id: "recurrencePattern",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.recurrencePattern) = $event))
                      }, _hoisted_68, 512), [
                        [_vModelSelect, formData.recurrencePattern]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (formData.type === 'bell_schedule')
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _hoisted_70,
                  _hoisted_71,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bellSchedule.periods, (period, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "bell-period"
                    }, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("h3", null, "Period " + _toDisplayString(index + 1), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-remove-period",
                          onClick: ($event: any) => (removePeriod(index))
                        }, [
                          _createVNode(_unref(FontAwesomeIcon), { icon: "times" })
                        ], 8, _hoisted_73)
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("label", {
                            for: 'periodName' + index
                          }, "Name", 8, _hoisted_76),
                          _withDirectives(_createElementVNode("input", {
                            id: 'periodName' + index,
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((period.name) = $event),
                            placeholder: "e.g., 1st Period, Lunch",
                            required: ""
                          }, null, 8, _hoisted_77), [
                            [_vModelText, period.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("label", {
                            for: 'periodType' + index
                          }, "Type", 8, _hoisted_79),
                          _withDirectives(_createElementVNode("select", {
                            id: 'periodType' + index,
                            "onUpdate:modelValue": ($event: any) => ((period.type) = $event)
                          }, _hoisted_86, 8, _hoisted_80), [
                            [_vModelSelect, period.type]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("label", {
                            for: 'periodStartTime' + index
                          }, "Start Time", 8, _hoisted_89),
                          _withDirectives(_createElementVNode("input", {
                            id: 'periodStartTime' + index,
                            type: "time",
                            "onUpdate:modelValue": ($event: any) => ((period.startTime) = $event),
                            required: ""
                          }, null, 8, _hoisted_90), [
                            [_vModelText, period.startTime]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("label", {
                            for: 'periodEndTime' + index
                          }, "End Time", 8, _hoisted_92),
                          _withDirectives(_createElementVNode("input", {
                            id: 'periodEndTime' + index,
                            type: "time",
                            "onUpdate:modelValue": ($event: any) => ((period.endTime) = $event),
                            required: ""
                          }, null, 8, _hoisted_93), [
                            [_vModelText, period.endTime]
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-add-period",
                    onClick: addPeriod
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
                    _createTextVNode(" Add Period ")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-cancel",
                onClick: goBack
              }, "Cancel"),
              _createElementVNode("button", {
                type: "submit",
                class: "btn-submit",
                disabled: isSubmitting.value
              }, [
                (isSubmitting.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_96, "Saving..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_97, "Update Event"))
              ], 8, _hoisted_95)
            ])
          ], 32))
  ]))
}
}

})